import React, {FC, memo, useEffect, useState} from "react";
import {InputNumber} from "antd";
import {InputNumberProps} from "antd/lib/input-number";
import css from "./MoneyInput.less";
import i18n from "../../services/i18n";
import {CurrencySettings, useCurrency} from "../../helpers/currencyHelper";

type MoneyInputProps = Omit<
    InputNumberProps,
    | "onBlur"
    | "onChange"
    // | "defaultValue"
    | "formatter"
    | "parser"
    | "precision"
> & {
    onChange?: (value: number | undefined) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    precision?: number;
};

type MoneyInputCSSProperties = React.CSSProperties & {
    // "--input-width": string;
    // "--currency": string;
    "--color": string;
};

const MoneyInput: FC<MoneyInputProps> = ({
    value,
    style,
    disabled,
    onChange = () => undefined,
    onBlur = () => undefined,
    precision,
    ...props
}) => {
    const currencySettings: CurrencySettings = useCurrency();
    // const [width, setWidth] = useState(value?.toString().length ?? 0);

    const handleChange = (value: number | undefined) => {
        // setWidth(value?.toString().length ?? 0);
        const digits = precision ?? 2;
        const formattedValue = Number(value?.toFixed(digits) ?? 0);
        onChange(formattedValue);
    };

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        // setWidth(event.target.value.length);
        onBlur(event);
    };

    const actualStyle: MoneyInputCSSProperties = {
        // "--input-width": `${width}ch`,
        // "--currency": '"€"',
        "--color": disabled ? "lightgrey" : "black",
        ...style,
    };

    return (
        <InputNumber
            disabled={disabled}
            style={actualStyle}
            className={css.root}
            onChange={(value) => handleChange(Number(value))}
            onBlur={handleBlur}
            lang={navigator.language}
            precision={precision}
            decimalSeparator={currencySettings.decimalSeperator}
            min={0}
            value={value}
            addonAfter={<span className={css.prefix}>{currencySettings.symbol}</span>}
            {...props}
        />
    );
};

export default memo(MoneyInput);
